import React, { useState } from 'react';
import api from '../services/api';

const AlgorithmTest = () => {
    const [domain, setDomain] = useState('www.manos-vip.store');
    const [channelUid, setChannelUid] = useState('');
    const [couponCode, setCouponCode] = useState('TEST_COUPON_123');
    const [logs, setLogs] = useState([]);

    const log = (message, data = null) => {
        const time = new Date().toLocaleTimeString();
        let logText = `[${time}] ${message}\n`;
        if (data) {
            logText += JSON.stringify(data, null, 2) + '\n';
        }
        setLogs(prev => [logText, ...prev]);
    };

    const handleGetAllocation = async () => {
        if (!domain) {
            alert('请输入域名');
            return;
        }
        
        try {
            log(`请求分配电话: GET /website_config/getAllocatedPhone?domain=${domain}`);
            const res = await api.get(`/api/website_config/getAllocatedPhone`, { params: { domain } });
            log('返回结果:', res);

            if (res.code === 1 && res.data && res.data.phone) {
                setChannelUid(res.data.phone);
            }
        } catch (err) {
            log('请求出错:', err.message);
        }
    };

    const handleTriggerConversion = async () => {
        if (!couponCode) {
            alert('请输入优惠券码');
            return;
        }

        const payload = {
            channelUid: channelUid || undefined,
            couponCode: couponCode,
            senderName: '测试用户',
            phone: '13800138000'
        };

        try {
            log(`触发进粉: POST /webhook/triggerConversionByCoupon`, payload);
            const res = await api.post(`/api/webhook/triggerConversionByCoupon`, payload);
            log('进粉结果:', res);
        } catch (err) {
            log('请求出错:', err.message);
        }
    };

    const handleResetFans = async () => {
        if (!window.confirm('确定要重置所有号码的当前进粉数吗？')) return;
        
        try {
            log(`重置进粉数: POST /phone_group/resetFans`);
            const res = await api.post(`/api/phone_group/resetFans`);
            log('重置结果:', res);
        } catch (err) {
            log('请求出错:', err.message);
        }
    };

    const clearLogs = () => {
        setLogs([]);
    };

    return (
        <div className="p-6 max-w-4xl mx-auto space-y-6">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800">📞 电话分组分配算法测试</h2>
            </div>

            <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
                <h3 className="text-lg font-medium text-gray-900 mb-2">1. 测试获取分配电话 (getByDomain)</h3>
                <p className="text-sm text-gray-500 mb-4">模拟前端加载配置，将根据小组比例和进粉情况动态返回一个最优电话号码。</p>
                <div className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">域名 (Domain)</label>
                        <input 
                            type="text" 
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                            value={domain}
                            onChange={(e) => setDomain(e.target.value)}
                            placeholder="例如: www.manos-lux.com"
                        />
                    </div>
                    <button 
                        onClick={handleGetAllocation}
                        className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
                    >
                        获取分配电话
                    </button>
                </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
                <h3 className="text-lg font-medium text-gray-900 mb-2">2. 模拟触发进粉 (Webhook 转化)</h3>
                <p className="text-sm text-gray-500 mb-4">模拟用户通过某个客服号码（Channel UID）发送消息触发了转化，这将使该号码的进粉数 +1。</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">客服号码 (Channel UID) - 选填</label>
                        <input 
                            type="text" 
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                            value={channelUid}
                            onChange={(e) => setChannelUid(e.target.value)}
                            placeholder="填入分配到的电话号码（可为空）"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">优惠券码 (Coupon Code)</label>
                        <input 
                            type="text" 
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500" 
                            value={couponCode}
                            onChange={(e) => setCouponCode(e.target.value)}
                            placeholder="例如: TEST_COUPON_123"
                        />
                    </div>
                </div>
                <button 
                    onClick={handleTriggerConversion}
                    className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors"
                >
                    模拟进粉 +1
                </button>
            </div>

            <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
                <h3 className="text-lg font-medium text-gray-900 mb-2">3. 测试重置当前进粉数 (归0)</h3>
                <p className="text-sm text-gray-500 mb-4">将所有电话号码的 `current_fans` 清零，重新开始一轮比例分配。</p>
                <button 
                    onClick={handleResetFans}
                    className="bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-colors"
                >
                    一键归0
                </button>
            </div>

            <div className="bg-white rounded-xl shadow-sm p-6 border border-gray-100">
                <div className="flex justify-between items-center mb-4">
                    <h3 className="text-lg font-medium text-gray-900">测试结果日志</h3>
                    <button 
                        onClick={clearLogs}
                        className="bg-gray-200 text-gray-700 px-3 py-1 rounded-md hover:bg-gray-300 transition-colors text-sm"
                    >
                        清空日志
                    </button>
                </div>
                <div className="bg-gray-900 rounded-lg p-4 h-64 overflow-y-auto">
                    {logs.length === 0 ? (
                        <div className="text-gray-400 text-sm">等待操作...</div>
                    ) : (
                        <pre className="text-green-400 text-xs font-mono whitespace-pre-wrap break-words">
                            {logs.join('\n')}
                        </pre>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AlgorithmTest;